import React from 'react'
import styled from '@emotion/styled'
import Button from 'library/atoms/Button'
import Icon from 'shared/library/atoms/Icon'
import { H3 } from 'library/atoms/Typography'
import useTranslation from 'next-translate/useTranslation'
import { SetActiveModalId } from 'shared/library/molecules/Modal'
import { MODAL_IDS } from '../Header/HeaderModals'
import Notification from '../Notification/Notification'
import Flex from 'shared/library/atoms/Flex'
import Link from 'next/link'
import routes from 'enums/routes'
import { useRouter } from 'next/router'
import useNotifications from 'state/useNotifications'

const ModalContentNotifications = ({
  setActiveModalId
}: {
  setActiveModalId: SetActiveModalId<MODAL_IDS>
}) => {
  const { notifications, useNotificationWatch } = useNotifications()

  useNotificationWatch()

  const { t } = useTranslation('common')
  const route = useRouter()
  const outletSlug = route.query.outletSlug as string

  const isOnNotificationsPage =
    route.pathname === routes['NOTIFICATIONS'].pathname

  return (
    <>
      <StyledModalHeader>
        <H3>{t('notifications')}</H3>
        <Flex>
          {!isOnNotificationsPage ? (
            <Link href={routes.NOTIFICATIONS.url({ outletSlug })} passHref>
              <Button variant="secondary">{t('view-all')}</Button>
            </Link>
          ) : (
            <Button variant="secondary" onClick={() => setActiveModalId(null)}>
              {t('view-all')}
            </Button>
          )}
          <Button
            aria-label={t('close')}
            variant="icon"
            onClick={() => setActiveModalId(null)}
          >
            <Icon size={14} name="close" color="grey" />
          </Button>
        </Flex>
      </StyledModalHeader>
      <StyledNotificationsContent>
        {/* Only showing the top 7 notifications to be consistent with the legacy business app */}
        {notifications
          ?.slice(0, 7)
          .map(notification => (
            <Notification notification={notification} key={notification.id} />
          ))}
      </StyledNotificationsContent>
    </>
  )
}

export default ModalContentNotifications

const StyledNotificationsContent = styled.div(({ theme }) => ({
  padding: theme.mixins.pxSpread([theme.space[0], theme.space[0]]),
  overflowY: 'auto'
}))

const StyledModalHeader = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.mixins.pxSpread([theme.space[4], theme.space[5]])
}))
